export const POLICY_NAMES = [
  'Accident and health',
  'Agriculture and forestry',
  'Auto or Motor',
  'Aviation',
  'Casualty / Liability',
  'Checkmate',
  'Contingency',
  'Cyber',
  'Energy',
  'Engineering',
  'Financial',
  'Internal Accounting',
  'Life',
  'LSOS Master Policy',
  'Marine',
  'Miscellaneous',
  'Norway',
  'Pensions',
  'Political risks',
  'Project',
  'Property',
  'Umbrella Liability',
] as const;
